import { OfferKindEnum } from '../../../../../services/exports/Constants';

const OfferLabel: Record<OfferKindEnum, string> = {
  [OfferKindEnum.PercentageOffByMinSpendValue]: '{{percentageAmount}}% reducere de la {{minSpendValue}}',
  [OfferKindEnum.PercentageOffByProducts]: 'Economisești {{percentageAmount}}% la produse selectate',
  [OfferKindEnum.AmountOffByProducts]: 'Economisești {{amount}} la produse selectate',
  [OfferKindEnum.AmountOffByMinSpendValue]: 'Economisești {{amount}} de la {{minSpendValue}}',
  [OfferKindEnum.Bogo]: '2 la prețul de 1 – Doar azi',
  [OfferKindEnum.BogoHalfPrice]: 'Cumpără unul, primești unul la jumătate de preț',
  [OfferKindEnum.FreeItemByProducts]: 'Azi: Obține produsul tău gratuit!',
  [OfferKindEnum.FreeItemByMinSpendValue]: 'Azi: Obține produsul gratuit la o valoare minimă a comenzii!',
};

export default OfferLabel;
